import { FC } from 'react';
import CardList from '../CardList';
import { CommonAttributesProps } from 'screens/AccessExpressV3/accessExpress.types';
import CardRadio from '../CardRadio';
import { SelectedAttributes } from './mobility.types';

interface ServiceorEquipmentProps extends CommonAttributesProps {
  dataPlanNeeded: SelectedAttributes['dataPlanNeeded'];
  setActivation: (
    value: ServiceorEquipmentProps['dataPlanNeeded']['activation'],
  ) => void;
  setDataPlanNeeded: (
    value: ServiceorEquipmentProps['dataPlanNeeded']['neededPlan'],
  ) => void;
}

const ServiceorEquipment: FC<ServiceorEquipmentProps> = ({
  handleStep,
  step,
  dataPlanNeeded,
  setActivation,
  setDataPlanNeeded,
}) => {
  const onSelect = (
    value: ServiceorEquipmentProps['dataPlanNeeded']['neededPlan'],
  ) => {
    if (value === 'no') handleStep && handleStep(step ?? 1);
    setDataPlanNeeded(value);
  };

  const onSelectActivation = (
    value: ServiceorEquipmentProps['dataPlanNeeded']['activation'],
  ) => {
    handleStep && handleStep(step ?? 1);
    setActivation(value);
  };

  return (
    <div className="space-y-4">
      <CardList
        title="Data plan needed?"
        selected={dataPlanNeeded.neededPlan}
        onClick={(value) =>
          onSelect(
            value as ServiceorEquipmentProps['dataPlanNeeded']['neededPlan'],
          )
        }
        options={[
          {
            id: 'yes',
            title: 'Yes, add a data plan',
          },
          {
            id: 'no',
            title: 'No',
          },
        ]}
      />
      {dataPlanNeeded.neededPlan === 'yes' ? (
        <CardRadio
          title="Activation preference"
          directionMessage="Choose whether the SIM should be active upon delivery or remain inactive until activated later."
          options={[
            {
              label: 'Active (Hot)',
              value: 'hot',
            },
            { label: 'Inactive (Cold)', value: 'cold' },
          ]}
          selected={dataPlanNeeded.activation}
          onClick={(value) =>
            onSelectActivation(
              value as ServiceorEquipmentProps['dataPlanNeeded']['activation'],
            )
          }
        />
      ) : null}
    </div>
  );
};

export default ServiceorEquipment;
